import { createEntityAdapter } from '@reduxjs/toolkit';
import { IArticleEdit } from 'application/editcomp/api/Article';

export const articleEditAdapter = createEntityAdapter<IArticleEdit, number>({
  selectId: (project) => project.articleID,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});
